module.exports = __webpack_public_path__ + "static/media/quote4.cb790e8b.png";